import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/react/24/outline';

function LatestOpportunities() {
  return (
    <div className='container mt-5 w-full'>
      <p className='text-lg text-gray-900 font-bold mb-4'>Latest Opportunities</p>
      <table className='table-auto w-full rounded-md'>
        <thead className='bg-gray-50 border-green-500 border-l-4 rounded-md'>
          <tr>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Project Name</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Address</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Sub-Market</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Project Type</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Construction Type</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Procurement Type</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Developer Partner</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>Sq.Ft</th>
            <th className='p-6 text-left text-xs font-bold text-gray-500 uppercase tracking-wider'>TDC</th>
          </tr>
        </thead>
        <tbody className='text-center divide-y rounded-md'></tbody>
      </table>
      <div className='flex bg-gray-50 w-full justify-end py-5 border-t text-neutralColor-normal text-sm'>
        <div className='flex justify-around gap-8 items-end font-semibold px-5'>
          <div>
            Rows per page:{' '}
            <select className='bg-white border rounded-md px-2 py-1' onChange={() => {}} defaultValue={10}>
              <option>5</option>
              <option>10</option>
              <option>15</option>
              <option>20</option>
            </select>
          </div>
          <div>1 of 5</div>
          <div className='cursor-pointer flex gap-2 items-center hover:text-secondaryColor-normal' id='prev' onClick={() => {}}>
            <ArrowLeftCircleIcon className='h-6 w-6' />
            <span>Prev</span>
          </div>
          <div className='cursor-pointer flex gap-2 items-center hover:text-secondaryColor-normal' onClick={() => {}}>
            <span>Next</span>
            <ArrowRightCircleIcon className='h-6 w-6' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LatestOpportunities;
